export default __webpack_public_path__ + "static/media/tech_store.c0cdff15.jpeg";